import type { JSX } from 'react';
import { Route, Routes, useNavigate } from 'react-router';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { LoginCallback, Security } from '@okta/okta-react';
import { Home } from './pages/home';
import { RequiredAuth } from './hooks/RequiredAuth';
import { Header } from './components/Header';
import { oktaAuth } from './utils/okta';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

function App() {
  const navigate = useNavigate();

  const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
    await navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  const isDev = import.meta.env.MODE !== 'development';

  const wrapWithAuth = (element: JSX.Element) => (isDev ? <RequiredAuth>{element}</RequiredAuth> : element);

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <Header />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Routes>
          <Route path="/login/callback" element={<LoginCallback />} />
          <Route path="/" element={wrapWithAuth(<Home />)} />
        </Routes>
      </LocalizationProvider>
    </Security>
  );
}

export default App;
